import { Feature, GeoJsonProperties, Point } from 'geojson';
import { IncidentEntity } from '@/features/hazards';

const MAX_RADIUS = 40;
const MIN_RADIUS = 5;
const MAX_MAGNITUDE_THRESHOLD = 9;
const MIN_MAGNITUDE_THRESHOLD = 3;

const getEarthquakeRadius = (magnitude: number): number => {
  if (magnitude < MIN_MAGNITUDE_THRESHOLD) return MIN_RADIUS;
  if (magnitude > MAX_MAGNITUDE_THRESHOLD) return MAX_RADIUS;

  return (
    MIN_RADIUS + (magnitude - MIN_MAGNITUDE_THRESHOLD) * ((MAX_RADIUS - MIN_RADIUS) / (MAX_MAGNITUDE_THRESHOLD - MIN_MAGNITUDE_THRESHOLD))
  );
};

export const replaceEarthquakeCircleFeatures = (earthquakeIncidents: IncidentEntity[]): Feature<Point, GeoJsonProperties>[] => {
  return earthquakeIncidents
    .map((earthquake) => {
      const magnitude = parseFloat(earthquake.earthquakeMagnitude!);
      const radius = getEarthquakeRadius(magnitude);

      const center = (earthquake.pointFeature?.geometry as Point).coordinates as [number, number] | null;
      if (!center) return null;

      const pointFeature: Feature<Point, GeoJsonProperties> = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: center,
        },
        properties: {
          ...earthquake,
          earthquakeMagnitude: magnitude,
          radius,
          id: earthquake.id,
          entityType: earthquake.entityType,
          entitySubType: earthquake.entitySubType,
        },
      };

      return pointFeature;
    })
    .filter(Boolean) as Feature<Point, GeoJsonProperties>[];
};
